<template>
  <v-row justify="space-between" align="center">
    <v-col cols="1">
      <v-avatar size="75" tile>
        <v-img :src="img" contain></v-img>
      </v-avatar>
    </v-col>
    <v-col cols="10" class="text-start">
      <v-card-title>{{ title }}</v-card-title>

      <v-card-subtitle>{{ $t('Language:', [$t(subtitle)]) }}</v-card-subtitle>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: ['title', 'subtitle', 'img', 'third', 'description', 'action'],
    data() {
      return {}
    },
  }
</script>
